// This file is automatically generated during build
export const version = process.env.REACT_APP_GIT_SHA || 'development'
